import React, { useEffect } from "react";
import PaymentAuthorization from "./payment-authorization";
import InvoiceStatement from "./invoice-statement";
import useResidualStore, {
  loadPaymentAuthOffices,
  loadPaymentAuthorizationReport,
  loadAgentAccountStatementReport,
} from "../../../../stores/residuals";

const ResidualReports = () => {
  const selectedReport = useResidualStore((state) => state.selectedReport);
  const selectedOffice = useResidualStore((s) => s.paymentAuthSelectedOffice);
  const appliedYear = useResidualStore((s) => s.paymentAuthAppliedPeriod.year);
  const appliedMonth = useResidualStore(
    (s) => s.paymentAuthAppliedPeriod.month,
  );
  const agentYear = useResidualStore((s) => s.agentStatementAppliedPeriod.year);
  const agentMonth = useResidualStore(
    (s) => s.agentStatementAppliedPeriod.month,
  );
  const agentPage = useResidualStore((s) => s.agentStatementPage);
  const officesLoading = useResidualStore((s) => s.paymentAuthOfficesLoading);
  const isPaymentAuthorization = selectedReport === "payment-authorization";
  const isInvoiceStatement = selectedReport === "invoice-statement";

  useEffect(() => {
    if (isPaymentAuthorization || isInvoiceStatement) {
      loadPaymentAuthOffices();
    }
  }, [isPaymentAuthorization, isInvoiceStatement]);

  useEffect(() => {
    if (isPaymentAuthorization) {
      loadPaymentAuthorizationReport();
    }
  }, [
    isPaymentAuthorization,
    selectedOffice,
    appliedYear,
    appliedMonth,
    officesLoading,
  ]);

  useEffect(() => {
    if (isInvoiceStatement) {
      loadAgentAccountStatementReport();
    }
  }, [
    isInvoiceStatement,
    selectedOffice,
    agentYear,
    agentMonth,
    agentPage,
    officesLoading,
  ]);

  switch (selectedReport) {
    case "payment-authorization":
      return <PaymentAuthorization />;
    case "invoice-statement":
      return <InvoiceStatement />;
    default:
      return null;
  }
};

export default ResidualReports;
